import { CSSObject } from '@emotion/react'

export const customProgressBarStyles = (): {
  [key: string]: Record<string, CSSObject | string | number>
} => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '8px',
    backgroundColor: '#FFFFFF',
    borderRadius: '20px',
    overflow: 'hidden',
    margin: '10px 0',
    borderTop: '1px solid #B9B9B9',
    borderLeft: '1px solid #B9B9B9',
    borderRight: '1px solid #B9B9B9',
  },
  filled: {
    height: '100%',
    borderRadius: '20px 0 0 20px',
    transition: 'width 0.3s ease',
  },
  unfilled: {
    height: '100%',
    backgroundColor: '#FFFFFF',
    transition: 'width 0.3s ease',
  },
})
